/**
 * Convert a backend ISO datetime to a value the <input type="date" /> control
 * accepts (`YYYY-MM-DD`).
 */
export const toDateInput = (s?: string | null): string => {
    if (!s) return ''
    const d = new Date(s)
    if (Number.isNaN(d.getTime())) return ''
    const pad = (n: number) => `${n}`.padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/**
 * Convert a `YYYY-MM-DD` value from a date input to an ISO datetime at the
 * start of the day in local time, so the backend keeps storing schedule_time
 * as a datetime field.
 */
export const fromDateInput = (s: string): string | null => {
    if (!s) return null
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s)
    if (!m) return null
    const [, y, mo, da] = m
    const d = new Date(Number(y), Number(mo) - 1, Number(da), 0, 0, 0, 0)
    if (Number.isNaN(d.getTime())) return null
    return d.toISOString()
}
